import { ErrorMessageEn, ErrorMessageEs } from '$constants/alerts';
import { errorHandler } from '$store/utils';
import {
  CandidateReactionsBuilder,
  DeleteReactionInput,
} from '../candidate-reactions.types';

export const deleteReaction = (builder: CandidateReactionsBuilder) =>
  builder.mutation<undefined, DeleteReactionInput>({
    query: ({ candidateId }) => ({
      url: `/candidate-reactions/${candidateId}`,
      method: 'DELETE',
    }),
    transformErrorResponse: (error, meta, { lang }) => {
      errorHandler(
        '[DeleteReactionAction]',
        lang === 'es'
          ? ErrorMessageEs.ErrorRemovingReaction
          : ErrorMessageEn.ErrorRemovingReaction,
        error,
        true
      );
    },
    invalidatesTags: (baseQuery, meta, { candidateId }) => [
      { type: 'candidateReactions', id: candidateId },
    ],
  });
